import React from 'react';
import { Navigate, useOutletContext, useParams } from 'react-router-dom';

import {
  IDENTITY_PROVIDERS,
  inputAcceptTransmitDataConfig,
  inputEmailConfig,
  inputEmailValidConfig,
  inputIdentityProviderConfig,
  inputServiceProviderConfig,
  inputTextareaDescriptionConfig,
} from '../../../configs';
import { PageLayoutContext, TechnicalFormValues } from '../../../interfaces';
import { FormName, FormType } from '../../../libs/enums';
import { getIdpLabelByValue } from '../../../libs/helpers';
import {
  CheckboxComponent,
  SelectComponent,
  TextAreaComponent,
  TextInputComponent,
} from '../../dsfr';
import { ErrorCodeComponent } from '../error-code';
import { FormWrapperComponent } from '../form-wrapper';
import { ReadOnlyComponent } from '../read-only';

interface RouteParams extends Record<string, string | undefined> {
  errorCode: string;
}

export const TechnicalForm = React.memo(() => {
  const { errorCode } = useParams<RouteParams>();
  const { errorId, idpName, platform, spName } = useOutletContext<PageLayoutContext>();

  const identityProvider = getIdpLabelByValue(idpName);
  const serviceProvider = (!!spName && spName) || undefined;

  if (!errorCode) {
    return <Navigate replace state={{ error: `${FormType.TECHNICAL}/${errorCode}` }} to="/error" />;
  }

  return (
    <FormWrapperComponent<TechnicalFormValues>
      initialValues={{
        acceptTransmitData: undefined,
        email: undefined,
        emailValid: undefined,
        errorCode,
        errorId,
        formName: FormName.TECHNICAL,
        formType: FormType.TECHNICAL,
        identityProvider,
        platform,
        serviceProvider,
        textareaDescription: undefined,
      }}>
      <React.Fragment>
        <div className="fr-grid-row fr-grid-row--gutters fr-mb-3w">
          <div className="fr-col-12 fr-col-sm-6 fr-mb-md-0 fr-mb-2w">
            <ErrorCodeComponent />
          </div>
          <div className="fr-col-12 fr-col-sm-6">
            {identityProvider ? (
              <ReadOnlyComponent {...inputIdentityProviderConfig} />
            ) : (
              <SelectComponent {...inputIdentityProviderConfig} values={IDENTITY_PROVIDERS} />
            )}
          </div>
        </div>
        {serviceProvider ? (
          <ReadOnlyComponent {...inputServiceProviderConfig} />
        ) : (
          <TextInputComponent {...inputServiceProviderConfig} />
        )}
        <TextInputComponent {...inputEmailConfig} />
        <TextInputComponent {...inputEmailValidConfig} />
        <TextAreaComponent
          {...inputTextareaDescriptionConfig}
          description="Merci de nous préciser la démarche que vous souhaitez effectuer."
        />
        <CheckboxComponent {...inputAcceptTransmitDataConfig} />
      </React.Fragment>
    </FormWrapperComponent>
  );
});

TechnicalForm.displayName = 'TechnicalForm';
